import dark1 from "./dark1";
import light1 from "./light1";
import light2 from "./light2";
Object.freeze(dark1);
Object.freeze(light1);
Object.freeze(light2);
export { dark1, light1, light2 };